import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';

const isAuthError = (error: FetchBaseQueryError | undefined) =>
  error !== undefined && error.status === 401;

export { isAuthError };
